export const AnimatedCounter = ({ value, suffix = "", className = "", display }) => {
  return (
    <span className={className}>
      {display ? display : `${value}${suffix}`}
    </span>
  );
};

export default AnimatedCounter;
